import { GetContactAttributeActivityResponse } from '../../types/activity/activity.types';

// Action type constants
export const GET_CONTACT_ATTRIBUTE_ACTIVITY_REQUEST =
  'GET_CONTACT_ATTRIBUTE_ACTIVITY_REQUEST';
export const GET_CONTACT_ATTRIBUTE_ACTIVITY_SUCCESS =
  'GET_CONTACT_ATTRIBUTE_ACTIVITY_SUCCESS';
export const GET_CONTACT_ATTRIBUTE_ACTIVITY_FAILURE =
  'GET_CONTACT_ATTRIBUTE_ACTIVITY_FAILURE';

// Action interfaces
export interface GetContactAttributeActivityRequestAction {
  type: typeof GET_CONTACT_ATTRIBUTE_ACTIVITY_REQUEST;
  payload: {
    contactId: string;
    page?: number;
    limit?: number;
  };
  [key: string]: any;
}

export interface GetContactAttributeActivitySuccessAction {
  type: typeof GET_CONTACT_ATTRIBUTE_ACTIVITY_SUCCESS;
  payload: GetContactAttributeActivityResponse;
  [key: string]: any;
}

export interface GetContactAttributeActivityFailureAction {
  type: typeof GET_CONTACT_ATTRIBUTE_ACTIVITY_FAILURE;
  payload: string;
  [key: string]: any;
}

// Union type for all activity actions
export type ActivityActionTypes =
  | GetContactAttributeActivityRequestAction
  | GetContactAttributeActivitySuccessAction
  | GetContactAttributeActivityFailureAction;
